import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import styled from "styled-components";
import Header from "../Header";
import LeftSidebar from "../LeftSidebar";
import {
  fetchSaasPlanList,
  fetchApprovalList,
} from "../../Owner/ownerAction";
import { fetchOrganisationEntities } from "../../appAction";
import { fetchUserDashboardStats } from "../../../redux/UserReducer/userAction";
import { showNotification } from "../../../util/Utility";
import DefaultModal from "../../../components/DefaultModal/DefaultModal";
import Button from "../../../components/Buttons";
import Label from "../../../components/Label";
import Icon from "@ant-design/icons";
import axios from "axios";
import { textAlign } from "styled-system";

const formatEntityList = (list) => {
  return list
    ?.filter((item) => item?._id)
    .map((item) => ({
      label: item.name,
      value: item._id,
    }));
};

const RightSide = styled.div`
  padding: 7.5rem 2rem 2rem 2rem;
  background: #faf4fd;
  height: 100vh;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #9197b3;
    border-radius: 5px;
  }
`;
const RightSideSection = styled.div`
  width: ${(props) => (props.open ? "100%" : "100%")};
`;

const NavbarSidebar = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [open, setOpen] = useState(true);

  const userDetails = useSelector((state) => state.appReducer?.user);
  const userType = useSelector((state) => state.appReducer?.userType);
  const [viewerEntities, setViewerEntities] = useState([])
  const [showSelectEntityModal, setShowSelectEntityModal ] = useState(false)
  const [selectedViewerEntity, setSelectedViewerEntity] = useState(null)

  useEffect(() => {
    console.log('data',userType)
    if (!userType) {
      localStorage.clear();
      window.location.href = `/login`;
    }
  }, [userType]);

  useEffect(() => {
    if (userDetails?.organisation_id) {
      dispatch(fetchOrganisationEntities(userDetails?.organisation_id));
    }
    if (userType === "product_owner") {
      console.log('here i am')
      dispatch(fetchSaasPlanList());
      dispatch(fetchApprovalList());
      dispatch(fetchUserDashboardStats());
    }
    if (userType === "viewer" && userDetails?._id) {
      
      if(userDetails.viewer_organisations?.length === 1){
        dispatch(fetchOrganisationEntities(userDetails?.viewer_organisations[0]));
      }
      else{
        const fetchViewerMosques=async()=>{
            try {
               const config = {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                  },
                };
              const res = await axios.get(`${process.env.REACT_APP_API_URL}onboarding/viewerById?viewerId=${userDetails._id}`, config)
              if(res.status === 200){
                 const formattedList = formatEntityList(res.data.viewer_organisations)
                 console.log('***********',res.data);
                 
                 setViewerEntities(formattedList)
                 
                //  dispatch(fetchOrganisationEntities(userDetails?.current_organisation));
              }
            } catch (error) {
              console.log(error);
              showNotification('error','error fetching viewer mosques')
            }
        }
        fetchViewerMosques()
      }
    }
  }, [dispatch, userDetails]);

  useEffect(()=>{
    if(viewerEntities.length>1){
      setShowSelectEntityModal(true)
    }
  },[viewerEntities])

  console.log('view entities', viewerEntities);
  

  const renderContainer = () => {
    if (
      location?.pathname === "/reset-password" ||
      location?.pathname === "/forget"
    ) {
      return <div className="container-fluid p-0">{children}</div>;
    }
    return (
      <div className="container-fluid p-0">
        <div className="d-flex">
          <LeftSidebar open={!!open} setOpen={setOpen} />
          <RightSideSection open={!!open}>
            <Header isCollapsed={open ? false : true}/>
            <RightSide open={true}>{children}</RightSide>
          </RightSideSection>
          <DefaultModal
          show={showSelectEntityModal}
          onHide={() => setShowSelectEntityModal(false)}
          className="add-mosque-modal"
          centered={true}
          showHeader={false}
          size=""
          showFooter={false}
        >
          <div>
            <Icon
              iconName="modalClose"
              iconSize="xs"
              style={{ marginLeft: "auto" }}
              onClick={() => setShowSelectEntityModal(false)}
            />
            <Label
              className="mosque_view_title"
              style={{ display: "flex", justifyContent: "center" }}
            >
              Select a Mosque to View
            </Label>
            <Label variant="text3" style={{textAlign:'center'}}  color="#7E7E7E">You’re associated with multiple mosques. Please choose the mosque you’d like to view to continue.</Label>
            <div style={{ maxHeight: "500px", overflow: "scroll", padding:'20px' }}>
              {viewerEntities?.map((entity) => (
                <div className="radio-group" key={entity._id} style={{ marginBottom: "10px" }}>
                  <label style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <input
                      type="radio"
                      name={entity.label}
                      value={entity.value}
                      checked={selectedViewerEntity === entity.value}
                      onChange={() => setSelectedViewerEntity(entity.value)}
                    />
                    {entity.label}
                  </label>
                </div>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginTop: "40px",
              }}
            >
              <button
                disabled={!selectedViewerEntity}
                className={!selectedViewerEntity? "gray-bt" : "fill-bt"}
                style={{ height: "50px", width: "150px" }}
                onClick={()=>{
                  dispatch(fetchOrganisationEntities(selectedViewerEntity))
                  setShowSelectEntityModal(false)
                }}
              >
                Proceed
              </button>
            </div>
          </div>
        </DefaultModal>
        </div>
      </div>
    );
  };

  return <>{renderContainer()}</>;
};

NavbarSidebar.propTypes = {
  children: PropTypes.element.isRequired,
};

export default NavbarSidebar;
